import { COMPLAINT_TWO_FACTOR_AUTH_TOKEN } from 'service/constants'

const TTL_MINUTES = 10
const TTL_MS = TTL_MINUTES * 60 * 1000

const readStorage = () => {
  try {
    const raw = sessionStorage.getItem(COMPLAINT_TWO_FACTOR_AUTH_TOKEN)
    if (!raw) return undefined

    const parsed = JSON.parse(raw)
    if (!parsed?.token || !parsed?.storedAt) {
      sessionStorage.removeItem(COMPLAINT_TWO_FACTOR_AUTH_TOKEN)
      return undefined
    }

    const isExpired = Date.now() - parsed.storedAt > TTL_MS
    if (isExpired) {
      sessionStorage.removeItem(COMPLAINT_TWO_FACTOR_AUTH_TOKEN)
      return undefined
    }

    return parsed
  } catch (error) {
    sessionStorage.removeItem(COMPLAINT_TWO_FACTOR_AUTH_TOKEN)
    return undefined
  }
}

const getToken = () => {
  const stored = readStorage()
  return stored?.token
}

const getStoredAt = () => {
  const stored = readStorage()
  return stored?.storedAt
}

const setToken = (token) => {
  if (!token) return

  const payload = {
    token,
    storedAt: Date.now(),
  }

  try {
    sessionStorage.setItem(
      COMPLAINT_TWO_FACTOR_AUTH_TOKEN,
      JSON.stringify(payload),
    )
  } catch (error) {
    // Silent fail
  }
}

const clearToken = () => {
  sessionStorage.removeItem(COMPLAINT_TWO_FACTOR_AUTH_TOKEN)
}

export default {
  getToken,
  setToken,
  clearToken,
  getStoredAt,
}
